module.exports = __webpack_public_path__ + "img/Button_Plus.9c0e569d.png";